/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import axios from 'axios';
import auth from '../../../common/auth';
import common from '../common/index';
import i18n from '../i18n/index';

export default {
  /* eslint-disable */
  convertArabicNumbers({ commit }, text) {
    return axios({
      url: `api/convertArabicNumbers?text=${text}`,
      method: 'GET',
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      console.log(`Invoking api/convertArabicNumbers failed with the following error: ${error}`);
    });
  },
  saveCPC({ commit }, data) {
    return axios({
      url: `api/saveCPC?refUrl=${data.value.refUrl}&publisherId=${data.value.publisherId}&cpc=${data.value.cpc}&clickid=${data.value.clickid}`,
      method: 'GET',
    }).then(() => {
      commit({ type: 'updateCPC', cpc: null });
      commit({ type: 'updatePublisherId', publisherId: null });
      commit({ type: 'updateRefUrl', refUrl: null });
      commit({ type: 'storeClickid', clickid: null });
    }).catch((error) => {
      console.log(`Invoking api/saveCPC failed with the following error: ${error}`);
    });
  },
  checkIfURLisBlocked({ commit }, data) {
    return axios({
      url: `api/checkIfURLisBlocked?refUrl=${data.value.refUrl}&publisherId=${data.value.publisherId}`,
      method: 'GET',
    }).catch((error) => {
      console.log(`Invoking api/checkIfURLisBlocked failed with the following error: ${error}`);
    });
  },
  updateIntegrationInfo({ commit }, data) {
    commit({ type: 'setIntegrationInfo', value: { name: data.name, data: data.value } });
  },
  getReferralUrl() {
    return axios({
      url: 'api/getRegisterUrl',
      method: 'GET',
    });
  },
  getDecodedStatus({ commit }, encoded) {
    return axios({
      url: 'api/getStatus',
      method: 'GET',
      params: {
        status: encoded,
      },
    });
  },
  getUserExistsInCore({ commit }, data) {
    return axios({
      url: 'api/userExistsInCore',
      method: 'GET',
      params: {
        msisdn: data,
      },
    });
  },
  getUserIsRegistered({ commit }, data) {
    return axios({
      url: 'api/isUserRegistered',
      method: 'GET',
      params: {
        msisdn: data,
      },
    });
  },
  proceedWithSearchingOpponent({ commit, rootState }) {
    // console.clear();
    console.log(`Invoking api/gameToResumeExists?msisdn=${rootState.common.userDetails.msisdn}`);
    return axios({
      method: 'get',
      url: 'api/gameToResumeExists',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      console.log('inside gameToResumeExists');
      const responseData = response.data;
      console.log('responseData:');
      console.log(responseData);
      if (responseData.responseEnum === 'NO_GAME_EXISTS') {
        console.log('NO_GAME_EXISTS');
        commit('game/setGamePending', false, { root: true });
        commit('game/setGameInProgress', false, { root: true });
      } else if (responseData.responseEnum === 'PENDING_GAME_EXISTS') {
        console.log('PENDING_GAME_EXISTS');
        commit('game/setGamePending', true, { root: true });
      } else if (responseData.responseEnum === 'OPERATION_SUCCESS') {
        console.log('OPERATION_SUCCESS');
        commit('game/setGamePending', false, { root: true });
        commit('game/setGameInProgress', true, { root: true });
      }
    }).catch((error) => {
      console.log(`Invoking api/proceedWithSearchingOpponent failed with the following error: ${error}`);
    });
  },
  updateUserForEmail({ commit }, payload ) {
    return axios({
      url: `api/verifyWebAppEmail?msisdn=${payload.msisdn}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    })
  },
  storeVersionInfo({ commit }) {
    return axios({
      url: 'publicapi/getVersionInfo',
      method: 'GET',
    }).then((response) => {
      commit({ type: 'setVersionInfo', value: JSON.parse(response.data.data) });
    }).catch((error) => {
      console.log(`unable to get version info: ${error}`);
    });
  },
  // eslint-disable-next-line
  testControllerForGoogleAnalytics({ commit }, payload) {
    return axios({
      url: `publicapi/logAnalytics?state=${payload.userDataObject.state}&trackingId=${payload.userDataObject.trackingId}&path=${payload.userDataObject.path}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Invoking api/logAnalytics failed with the following error: ${error}`);
    });
  },
  getRequiredServerData({ dispatch }) {
    return dispatch('profile/getUserLoginDetails', null, { root: true })
      .then(() => dispatch('i18n/getLocaleAndTranslations', null, { root: true }))
      .then(() => dispatch('profile/storeAvailablePrizeTypes', localStorage.getItem('locale'), { root: true }))
      .then(() => dispatch('facebookSDKApi'))
      .then(() => dispatch('profile/storeVisitorWinners', localStorage.getItem('locale'), { root: true }))
      .then(() => dispatch('setSplashProperties'))
      .then(() => dispatch('setApplicationProperties'));
  },
  sendFacebookImage({ commit }) {
    console.log('SendFacebookImage Process in Duel db');
    return axios({
      url: 'api/updateFacebookImage',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        facebookImage: localStorage.getItem('FacebookImage'),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('deletePreviousFacebookImage');
        commit('storeFacebookImage', localStorage.getItem('FacebookImage'));
        // avatar Gender is missing
      }
      console.log(response);
    });
  },
  setSplashProperties({ commit }) {
    return axios({
      url: `publicapi/getSplashProperties`,
      method: 'GET',
    }).then((response) => {
      // success callback
      commit({ type: 'updateSplashUrl', value: response.data.data.splashUrl });
      commit({ type: 'updateSplashTimer', value: response.data.data.splashTimer });
    }).catch((error) => {
      console.log(`Invoking public/getSplashProperties failed with the following error: ${error}`);
    });
  },
  phoneShortcutInstalled({ commit }, payload) {
    console.log("Invoking phoneShortcutInstalled");
    return axios({
      url: 'api/phoneShortcutInstalled',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        shortcutCreated: payload.shortcutCreated,
      },
    }).then((response) => {
      commit({ type: 'storeHomeScreenModalDisable', value: response.data });
    }).catch((error) => {
      console.log(`Invoking phoneShortcutInstalled failed with the following error: ${error}`);
    });
  },
  updateDisplayAvatar({ commit }) {
    return axios({
      url: 'api/updateDisplayAvatar',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((responseDisplayAvatar) => {
      if (responseDisplayAvatar.data.responseEnum === 'OPERATION_SUCCESS') {
        console.log('------responseDisplayAvatar-------------', responseDisplayAvatar.data.data);
        commit({ type: 'setDisplayAvatar', item: responseDisplayAvatar.data.data });
      }
    }, (responseDisplayAvatar) => {
      // error callback
      // eslint-disable-next-line
      console.log(responseDisplayAvatar);
    });
  },
  sendAvatarCall({ commit }, avatarGenderChoice) {
    console.log('SendAvatar Process in Duel db');
    return axios({
      url: 'api/updateAvatar',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        avatar: localStorage.getItem('Avatar'),
        avatarGender: avatarGenderChoice,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('deletePreviousAvatar');
        commit('storeAvatar', localStorage.getItem('Avatar'));
        commit('setNewAvatarGender', avatarGenderChoice);
        commit('storeUserAvatar', localStorage.getItem('Avatar'));
        // avatar Gender is missing
      }
      console.log(response);
    }).catch((error) => {
      console.log(`Invoking api/updateAvatar failed with the following error: ${error}`);
    });
  },
  reOptinProcess() {
    console.log('Resubscribe user Call');
    return axios({
      url: 'api/reoptin',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Invoking api/reoptin failed with the following error: ${error}`);
    });
  },
  optoutCall() {
    return axios({
      url: 'api/optout',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Invoking api/optout failed with the following error: ${error}`);
    });
  },
  storeOperator({ commit }, operator) {
    commit({ type: 'setOperator', value: operator });
  },
  setApplicationProperties({ commit, dispatch }) {
    return axios({
      url: 'publicapi/getApplicationProperties',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const {
        showMaskProfileEdit,
        minGamesToPlay,
        showMsisdnInProfilePage,
        hideChangePassword,
        hideLangSelection,
        addOnGameMode,
        hideLeaderboard,
        numberOfQuestionsPerRound,
        mergedParam,
        integrationConfig,
        messaging,
        multiOperatorEnabled,
        multiOperatorKeys,
        multiOperatorDisplayedNamesInRegisterPage,
        multiOperatorDisplayNames,
        trackingId,
        puzzleGameCss,
        fallingItemsGameCss,
        duelSkin,
        timeRoundList,
        timeToAcceptChallenge,
        avatarGrouping,
        freeTrialStripe,
        logoOnFooter,
        vatBanner,
        facebookPixelId,
        phoneShortcutEnabled,
        reoptinOnestep,
        connectionPoints,
        twoStepRegistration,
        simpleRegistration,
        finalRoundNumber,
        facebookFunctionality,
        hideWinners,
        chatEnabled,
        hidePrizePage,
        winnersShowMsisdn,
        purchaseBundleFromUnsubUser,
        timeWinnerIndication,
        conversionForArabicFields,
        freeTrialRedirectionUrl,
        shareAchievementPoints,
        inviteConfig,
        pushNotificationsInfo,
        isCrossPromotionEnabled,
        postGameSettings,
        freeTrialPoints,
        timerForPuzzleGame,
        timerForLanternGame,
        paypalClientId,
        paypalThresholdForBundle,
      } = response.data.data;
      commit({ type: 'setShowMaskProfileEdit', value: showMaskProfileEdit });
      commit({ type: 'setAddOnMode', value: addOnGameMode });
      commit({ type: 'setMinGamesToPlay', value: minGamesToPlay });
      commit({ type: 'setShowMsisdnInProfilePage', value: showMsisdnInProfilePage });
      commit({ type: 'setHideChangePassword', value: hideChangePassword });
      commit({ type: 'setHideLangSelection', value: hideLangSelection });
      commit({ type: 'setHideLeaderboard', value: hideLeaderboard });
      commit('game/storeNumberOfQuestionsPerRound', { value: numberOfQuestionsPerRound }, { root: true });
      commit({ type: 'setMergedParam', value: mergedParam });
      commit({ type: 'setIntegrationConfig', value: JSON.parse(integrationConfig)});
      commit({ type: 'updateAvatarGrouping', value: avatarGrouping });
      commit({ type: 'updateFreeTrialStripe', value: freeTrialStripe });
      commit({ type: 'updateLogoOnFooter', value: logoOnFooter });
      commit({ type: 'updateTrackingId', value: trackingId });
      commit({ type: 'updateVatBanner', value: vatBanner });
      commit({ type: 'updateFacebookPixelId', value: facebookPixelId });
      commit({ type: 'updatePhoneShortcut' , value: phoneShortcutEnabled });
      commit({ type: 'updateReoptinOnestep', value: reoptinOnestep });
      commit({ type: 'storeConnectionPoints', value: connectionPoints });
      commit({ type: 'updateTwoStepRegistration', value: twoStepRegistration });
      commit({ type: 'updateSimpleRegistration', value: simpleRegistration });
      commit({ type: 'setLastRandomRound', value: finalRoundNumber });
      commit({ type: 'storeFacebookFunctionality', value: facebookFunctionality });
      commit({ type: 'setHideWinners', value: hideWinners });
      commit({ type: 'storeTimeRounds', value: timeRoundList });
      commit({ type: 'storeWinnersShowMsisdn', value: winnersShowMsisdn });
      commit({ type: 'storeHidePrizePage', value: hidePrizePage });
      commit({ type: 'setPurchaseBundleFromUnsubUser', value: purchaseBundleFromUnsubUser });
      commit({ type: 'setTimeWinnerIndication', value: timeWinnerIndication });
      commit({ type: 'updateChatStatus', value: chatEnabled });
      commit({ type: 'updateConversionForArabicFields', value: conversionForArabicFields });
      commit({ type: 'updateFreeTrialRedirectionUrl', value: freeTrialRedirectionUrl });
      commit({ type: 'updateTimeToAcceptChallenge', value: timeToAcceptChallenge });
      commit({ type: 'updateTimeToAcceptChallenge', value: timeToAcceptChallenge });
      commit({ type: 'updateMessagingConfig', value: JSON.parse(messaging) });
      commit({ type: 'setMultiOperator', value: multiOperatorEnabled });
      commit({ type: 'setShareAchievementPoints', value: shareAchievementPoints });
      commit({ type: 'setInviteConfig', value: JSON.parse(inviteConfig) });
      commit({ type: 'storePushNotificationsPublicKey', value: pushNotificationsInfo });
      commit({ type: 'updateCrossPromotion', value: isCrossPromotionEnabled });
      commit({ type: 'setTimerForPuzzleGame', value: timerForPuzzleGame});
      commit({ type: 'setTimerForLanternGame', value: timerForLanternGame});
      commit({ type: 'setPostGameSettings', value: postGameSettings});
      commit({ type: 'updateFreeTrialPoints', value: freeTrialPoints });
      commit({ type: 'setFallingItemsAddOnGameCss', value: fallingItemsGameCss });
      commit({ type: 'storePuzzleGameCss', value: puzzleGameCss });
      commit({ type: 'storePaypalClientId', value: paypalClientId });
      commit({ type: 'storePaypalThresholdForBundle', value: paypalThresholdForBundle });



      if (multiOperatorEnabled) {
        commit({ type: 'setMultiOperatorKeys', value: multiOperatorKeys });
        commit({ type: 'setMultiOperatorDisplayNames', value: multiOperatorDisplayNames });
        commit({ type: 'setMultiOperatorDisplayedNamesInRegisterPage', value: multiOperatorDisplayedNamesInRegisterPage });
      }
      localStorage.setItem('ga_tracking', trackingId);
      localStorage.setItem('duelSkin', duelSkin);
      commit({ type: 'storeDuelSkin', value: duelSkin });
      dispatch('common/skinCss', null, { root: true });
    }).catch((error) => {
      console.log(`Invoking api/getApplicationProperties failed with the following error: ${error}`);
    });
  },
  skinCss() {
    if (i18n.state.currentLocale === 'AR' || i18n.state.currentLocale === 'FA' || i18n.state.currentLocale === 'KU') {
      document.getElementById('skinid').href = `/static/skins/skin_${localStorage.getItem('duelSkin') || common.state.duelSkin}/css/skin_AR.css`;
    } else {
      document.getElementById('skinid').href = `/static/skins/skin_${localStorage.getItem('duelSkin') || common.state.duelSkin}/css/skin.css`;
    }
  },
    // eslint-disable-next-line
  facebookSDKApi({ commit, state }) {
    return axios({
      url: 'publicapi/getFbInfo',
      method: 'GET',
    }).then((response) => {
      /* eslint-disable */
      commit({ type: 'setFbAppId', value: response.data.data });
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: response.data.data,
          autoLogAppEvents: true,
          xfbml: true,
          cookie: true,
          version: 'v6.0',
          status: true,
        });
      };
      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) window.FB = null;
        js = d.createElement(s);
        js.id = id;
        js.src = `//connect.facebook.net/${state.availableFBLanguagesForSDK[i18n.state.currentLocale]}/all.js#version=v6.0&appId=${response.data.data}&status=true&cookie=true&xfbml=true`;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      // according to facebookIntegration methods for Api calls
      window.connectTofb = null;
      window.loginTofb = null;
      /* eslint-enable */
    });
  },
  // eslint-disable-next-line
  sendPushSubscriptionInfoToServer({ commit, dispatch }, sub) {
    axios({
      url: 'api/sendPushSubscriptionInfo',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        pushSubInfo: JSON.stringify(sub),
      },
    }).then((response) => {
      console.log('send sub response: ', response);
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        localStorage.setItem('subId', response.data.data);
        dispatch('profile/broadcastLogin', '', { root: true });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/common/actions.js